import { Box, Container, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Footer } from 'src/components/Footer';
import RedesSociales from './RedesSociales';

const OverviewWrapper = styled(Box)(
  () => `
    overflow: auto;
    flex: 1;
    overflow-x: hidden;
    align-items: center;
`
);

const RedesSocialesPage = () => {
  return (
    <>
      <Helmet>
        <title>Redes Sociales RetailView</title>
      </Helmet>
      {/* <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper> */}
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={4}
        >
          <Grid item lg={8} xs={12}>
            <RedesSociales />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default RedesSocialesPage;
